export const FIRM_DOCUMENT_FILTER_OPTIONS_QUERY_KEY = 'firm-document-filter-options';
export const FIRM_DOCUMENT_FILTER_OPTIONS_QUERY_STALE_TIME_MS = 60_000;
